import React, { useState, useEffect } from "react";
import "./style/SignUpScreen.module.scss";
import "react-phone-input-2/lib/style.css";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import { useSignUpScreen } from "./hooks/useSignUpScreen";
import FInputt from "../../components/FInputt/FInputt";
import PhoneInput from "react-phone-input-2";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fselect from "../../components/Finputs/Fselect/Fselect";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { UAParser } from "ua-parser-js";
import { useFormat } from "../../hooks/useFormat";

const SignUpScreen = ({ param }) => {
  const { formik, parameters, dataSelectIco2, route, setMetaDataTermsOfService } = useSignUpScreen();
  const { formatDateHour } = useFormat();
  const [ubicacion, setUbicacion] = useState(null);
  const [IpConnection, setIpConnection] = useState(null);
  const [typeDevice, setTypeDevice] = useState(null);
  const parser = new UAParser();


  useEffect(() => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
  
    function success(pos) {
      setUbicacion(pos.coords)
    }
  
    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    
    navigator.geolocation.getCurrentPosition(success, error, options);

    const getIP = async () => {
      return await fetch('https://api.ipify.org?format=json')
        .then(response => response.json());
    }

    getIP().then(response => {
      setIpConnection(response.ip)
    });

    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
      setTypeDevice("MOBILE")
    } else {
      setTypeDevice("PC")
    }


  }, []);

  useEffect(() => {
    let result = parser.getResult();
    let _metaData = {
      user_metadata: {
        deviceInfo: {
          os: {
            name: result.os.name,
            version: result.os.version
          },
          mac_address: null,
          model: !result.device.model ? null : result.device.model,
          manufacter: null,
          browser: {
            name: result.browser.name,
            version: result.browser.version
          },
          type: typeDevice,
          extra: null
        },
        geoInfo: {
          latitude: !ubicacion ? null : ubicacion.latitude,
          longitude: !ubicacion ? null : ubicacion.longitude,
          ip_connection: !IpConnection ? null : IpConnection,
          timeStamp: (new Date()).toISOString(),
          extra: null
        },
        app: {
          build: "1",
          platform: "WEB"
        }
      },
      agreements: [
        { id: "PAGRE_MX" }
      ]
    }
    setMetaDataTermsOfService(_metaData)
  }, [ubicacion,IpConnection,typeDevice]);



  return (
    <>
      <div className="sm:border-0 sm:border-red-600 sm:h-screen sm:relative sm:grid sm:place-items-center">
        <div className="w-screen border-0 h-[47rem] sm:w-[670px] md:w-[770px] lg:w-[970px]  sm:shadow-2xl sm:absolute border-red-600 grid grid-rows-6 sm:grid-rows-1 grid-cols-1 sm:grid-cols-12">
          <div
            className="absolute pt-10 sm:pt-6 pl-5 sm:pl-5 z-50 cursor-pointer"
            onClick={() => {
              route("/");
            }}
          >
            <div className="w-11 h-11 bg-white rounded-full grid place-items-center">
              <ArrowLeftIcon className="w-6" />
            </div>
          </div>
          <img
            src={require("../../components/assets/images/3-h.png")}
            className="border-0 hidden sm:block border-red-600 w-full h-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />
          
          <img
            src={require("../../components/assets/images/3-v.png")}
            className="border-0 sm:hidden block border-red-600 w-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />

          <div className="border-0 absolute sm:pl-[50%] md:pl-[50%]  pt-[45%] sm:pt-0 border-blue-600 w-full sm:h-[100%] row-span-3 sm:grid-rows-1 col-span-5 sm:grid sm:items-center">
            <div className="border-0 border-black w-full h-full  px-10">
              <div className="border-0 text-[5vw] sm:text-[24px] md:text-[27px] font-bold  grid place-items-center pt-5">¡Bienvenido a Fiado!</div>
              {!!parameters.state ? (
                <div className="border-0 grid place-items-center text-[5vw] sm:text-[24px] md:text-[27px]  font-semibold text-Secondary">
                  <FiconPhoneNumber
                    sizeIcon="28px"
                    phoneNumber={parameters.state.phoneNumber}
                  />
                </div>) : null}
              {!parameters.state ? (
                <FInputText
                  type="PhoneInput"
                  title="Teléfono"
                  placeholder="Ingresa tu teléfono"
                  value={formik.values.phoneNumber}
                  onChange={(value) => {
                    formik.setFieldValue("phoneNumber", value);
                  }}
                  errorMessage={formik.errors.phoneNumber}
                />
              ) : null}
              <FInputText
                title="Nombre"
                placeholder="Ingresa tu nombre"
                value={formik.values.name}
                onChange={(value) => {
                  formik.setFieldValue("name", value);
                }}
                errorMessage={formik.errors.name}
              />
              <Fselect
                type="SelectIcon"
                title="Lugar de nacimiento"
                value={[formik.values.countryId]}
                options={dataSelectIco2}
                onChange={(data) => {
                  formik.setFieldValue("countryId", data);
                }}
              />
              <FInputt
                type="DatePicker"
                name="birthDate"
                title="Fecha de nacimiento"
                formik={formik}
              />
              <FInputText
                title="Crea tu contraseña"
                placeholder="Crea tu contraseña"
                type="PasswordInput"
                maxLength={15}
                onChange={(value) => {
                  formik.setFieldValue("password", value);
                }}
                errorMessage={formik.errors.password}
              />
              <div className="border-0 w-full grid grid-cols-12 pt-5">
                <div className="border-0 col-span-1 grid place-items-center">
                  <input
                    type="checkbox"
                    className="float-left accent-[#0891b2]"
                    checked={formik.values.termsOfService}
                    onChange={(e) => {
                      formik.setFieldValue("termsOfService", e.target.checked);
                    }}
                  />
                </div>
                <div className="border-0 col-span-11 text-[4vw] xs:text-[15.5px]">
                  Acepto los términos y condiciones
                </div>
                <div className="border-0 col-span-1 grid place-items-center">
                </div>
                <div className="border-0 col-span-11 text-[4vw] xs:text-[14px] font-bold text-Secondary cursor-pointer">
                  <span onClick={() => {
                    // route("/TermsAndConditions");
                  }}>Ver más</span>
                </div>
              </div>
              <div className="pb-5">
                <Fbutton
                  value={"Registrarme"}
                  disabled={!(formik.isValid && formik.dirty)}
                  onClick={formik.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpScreen;
